import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from '@carbon/react';
import { PaintBrush, Notification, Security } from '@carbon/icons-react';
import { SettingsNav } from './components';
import formStyles from '../shared/FormPageLayout.module.scss';
import styles from './SettingsLayout.module.scss';
import tw from './SettingsLayout.tailwind.module.scss';

const navItems = [
  {
    title: 'Préférences',
    href: '/settings/preferences',
    icon: PaintBrush,
    description: 'Thème, langue et personnalisation',
  },
  {
    title: 'Notifications',
    href: '/settings/notifications',
    icon: Notification,
    description: 'Gérer vos notifications',
  },
  {
    title: 'Confidentialité',
    href: '/settings/privacy',
    icon: Security,
    description: 'Consentements et données personnelles',
  },
];

function sectionTitleForPath(pathname: string): string {
  if (pathname === '/settings' || pathname === '/settings/preferences') {
    return 'Préférences';
  }
  if (pathname === '/settings/notifications') return 'Notifications';
  if (pathname === '/settings/privacy') return 'Confidentialité';
  return 'Préférences';
}

export default function SettingsLayout() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const sectionTitle = sectionTitleForPath(pathname);

  return (
    <div className={formStyles.pageContainer}>
      <header className={formStyles.heroHeader}>
        <div className={formStyles.breadcrumbs}>
          <Breadcrumb noTrailingSlash>
            <BreadcrumbItem onClick={() => navigate('/profile')}>
              <span className={tw.u1}>Profil</span>
            </BreadcrumbItem>
            <BreadcrumbItem onClick={() => navigate('/settings')}>
              <span className={tw.u1}>Paramètres</span>
            </BreadcrumbItem>
            <BreadcrumbItem isCurrentPage>
              <span>{sectionTitle}</span>
            </BreadcrumbItem>
          </Breadcrumb>
        </div>
        <div className={formStyles.titleSection}>
          <h1>Paramètres</h1>
          <p>Gérez vos préférences et paramètres de compte</p>
        </div>
      </header>

      <div className={formStyles.mainLayout}>
        <div className={styles.settingsBody}>
          <div className={styles.tabBar}>
            <SettingsNav items={navItems} />
          </div>
          <main className={styles.main}>
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
